import React, { AllHTMLAttributes } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
//import { Hooks } from "@xt/xtbase";
//import store from "store";
import { Table, TableProps } from "antd";
import Loading from "./Loading";
import NoData from "./NoData";
import styles from "./index.module.scss";
interface SafetyTableProps<RecordType = any> extends TableProps<RecordType> {
  className?: string;
  data?: RecordType[];
  loading?: boolean;
  nodata?: React.ReactNode;
  onExpand?(expanded: boolean, record: RecordType): void;
}

//const { useTranslation } = Hooks;
const SafetyTable: React.FC<SafetyTableProps> = ({ className, data, loading = false, nodata = "", columns, onExpand, ...restProps }) => {
  //const t = useTranslation();
  //const {isLogin} = store.user;
  // method
  const handleExpandedRowsChange = (expanded: boolean, record: ObjAny) => {
    onExpand && onExpand(expanded, record);
  };
  return (
    <div className={cx(styles.account_table, className)}>
      {loading && <Loading />}
      {!data?.length && <NoData nodata={nodata} />}
      {!!data?.length && (
        <Table
          rowKey={(record, index) => {
            return record.id || index;
          }}
          columns={columns}
          dataSource={data}
          pagination={false}
          expandable={{ onExpand: handleExpandedRowsChange }}
          {...restProps}
        ></Table>
      )}
    </div>
  );
};
export default observer(SafetyTable);
